// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"84":"363f7942","122":"bd32ed0b","164":"c0f4925f","503":"20859cb9","739":"20859cb9","810":"0f8c468e"}[chunkId] + ".chunk.css";
};